// extracted by mini-css-extract-plugin
export default {"wrapper":"PersonPage_wrapper__7SyoC","person__name":"PersonPage_person__name__a7o+u","container":"PersonPage_container__Q79Ul"};